import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
// AOS
import AOS from "aos";
import "aos/dist/aos.css";

import DisplayProjects from "../DisplayProjects/DisplayProjects";

const Projects = () => {
  // AOS
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    fetch("https://radiant-meadow-70732.herokuapp.com/allProjects")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);
  return (
    <div id="projects" className="mb-5">
      <h2 className="fs-1 my-5">Projects</h2>

      <Row xs={1} md={3} className="g-4 mx-5 my-5" data-aos="fade-up">
        {projects.map((project) => (
          <DisplayProjects
            key={project._id}
            project={project}
          ></DisplayProjects>
        ))}
      </Row>

      <Link style={{ textDecoration: "none" }} to="/explore">
        <span
          style={{
            background:
              "linear-gradient(280deg, rgba(89,198,255,1) 0%, rgba(11,163,242,0.5945728633250176) 35%, rgba(11,106,218,1) 100%)",
            padding: "1rem",
            color: "white",
            fontSize: "1.2rem",
          }}
        >
          View All Projects {}
        </span>
      </Link>
    </div>
  );
};

export default Projects;
